/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface GroupPut {
  /** @example "Группа поставщиков номер 1" */
  name: string;
}

export type Group = GroupPut & {
  /** @example "group-1" */
  code: string;
};

export interface ClientProfile {
  address?: string;
  isPickup?: boolean;
  warehouse?: {
    address: string;
    workingHours?: string[];
  };
  mop?: {
    name: string;
    phone: string;
    email: string;
  };
  mrk?: {
    name: string;
    phone: string;
    email: string;
  };
  rop?: {
    name: string;
    phone: string;
    email: string;
  };
  class?: string;
  isUU?: boolean;
  participantType?: "physical" | "legal";
  rbCommission?: number;
  extraCharge?: number;
  discount?: number;
  postponement?: number;
  creditLimit?: number;
  overdueSum?: number;
  overdueDays?: number;
  prepaymentAmount?: number;
  holding?: string;
  paymentEmail?: string;
}

export interface ClientPut {
  /** @example "ООО Гарант плюс" */
  name: string;
  deliveryDayType: "calendar" | "work";
  /** @example "123456!Qw" */
  password: string;
  status: "enabled" | "disabled";
  roles?: ("suggest" | "orders")[];
  /**
   * Who can impersonate by user
   * @example "sys"
   */
  parent?: string;
  /** @example "logo-group-1" */
  logisticGroup: string;
  groups: string[];
  requestLimits?: {
    "5"?: number;
    concurrent?: number;
  };
  chestnyZnakBehaviour?: "none" | "decline" | "require";
  chestnyZnakKizTransfer?: "required" | "if_exists" | "dont_send";
}

export type Client = ClientPut & {
  /** @example "my_login" */
  login: string;
};

export type RichClient = Client & ClientProfile;

export interface SuggestionLog {
  /** @format datetime */
  time: string;
  client: {
    login?: string;
    name?: string;
    mop?: string;
    holding?: string;
  };
  brand: string;
  article: string;
  withAnalogs: boolean;
  stats: {
    totalCount: number;
    local: {
      proposalsInitialCount: number;
      /** @format int32 */
      proposalsCount: number;
      /** @format int32 */
      pricelistsCount: number;
      minPrice: number;
      queryTime: number;
    };
    analog: {
      proposalsInitialCount?: number;
      /** @format int32 */
      proposalsCount: number;
      /** @format int32 */
      pricelistsCount: number;
      minPrice: number;
      queryTime: number;
    };
    webSupplier: Record<
      string,
      {
        proposalsInitialCount?: number;
        /** @format int32 */
        proposalsCount: number;
        /** @format int32 */
        pricelistsCount: number;
        minPrice: number;
        queryTime: number;
      }
    >;
  };
  requestedFrom: "tradesoft" | "admin" | "client";
  queryTime: number;
}

export interface WSSuggestionLog {
  /** @format datetime */
  time: string;
  client: {
    login?: string;
    name?: string;
    mop?: string;
  };
  brand: string;
  article: string;
  withAnalogs: boolean;
  webSupplier: {
    code: string;
    name: string;
  };
  stats: {
    totalCount: number;
    target: {
      /** @format int32 */
      proposalsCount: number;
      minPrice: number;
    };
    analog: {
      /** @format int32 */
      proposalsCount: number;
      minPrice: number;
    };
  };
  requestedFrom: "tradesoft" | "admin" | "client" | "basket-refresh";
  queryTime: number;
}

export interface LogisticGroupPatch {
  /** @example "Лог группа 1" */
  name: string;
}

export interface LogisticGroupPost {
  /** @example "logo-group-1" */
  code: string;
  /** @example "Лог группа 1" */
  name: string;
}

export type LogisticGroup = LogisticGroupPost & {
  clients: string[];
};

export interface Delivery {
  /** @example "w=avtoformula;l=group-1" */
  pk?: string;
  subject: {
    type: "priceList" | "webSupplier";
    /** @example "42" */
    identifier?: string;
  };
  purpose: {
    type: "logisticGroup" | "client";
    /**
     * logistic group code or login
     * @example "group-1"
     */
    identifier: string;
  };
  intervals: {
    monday: DeliveryInterval;
    tuesday: DeliveryInterval;
    wednesday: DeliveryInterval;
    thursday: DeliveryInterval;
    friday: DeliveryInterval;
    saturday: DeliveryInterval;
    sunday: DeliveryInterval;
  };
}

export interface DeliveryInterval {
  /** @example "12:00:00" */
  hourDelimiter: string;
  before: {
    expected: number;
    guaranteed: number;
  };
  after: {
    expected: number;
    guaranteed: number;
  };
}

export interface WorkCalendarPut {
  holidays?: string[];
}

export type WorkCalendar = WorkCalendarPut & {
  /** @example 2026 */
  year: number;
};

export interface Filter {
  /**
   * ## Обрезается до 256 знаков справа!
   *
   * Первая часть - прайс или веб поставщик и идентификатор через `=`
   * - g группа, например l=group
   * - c клиент, например c=my-login
   *
   * Через точку с запятой вторая часть - тип объекта и идентификаторы через `,` после `=`
   * - p_ прайс, например p_=SWCY
   * - pg группа прайсов, например pg=group
   * - pl прайслист с лейблом, например pl=used
   * - bn номенклатура бренда, например bn=bmw,blk-c-555
   * - tl бренд или номенклатура у конкретного поставщика/прайса/группы прайсов
   *
   * Примеры каждого типа:
   * - g=group;p_=SXYY
   * - g=group;pl=used
   * - c=my_login;b_=bmw
   * - c=my_login;bl=oil
   * - c=my_login;bn=bmw,blk-c-555
   * - c=my_login;nl=counterfeit
   * - c=my_login;bp=bmw,SXYY
   * - c=my_login;ws=tradesoft
   * - c=my_login;wa=tradesoft
   * - c=my_login;wp=tradesoft,новосибирск
   */
  pk?: string;
  for: {
    type: "group" | "client";
    /** @example "my_login" */
    identifier: string;
  };
  object: FilterObject;
  /** @example [{"type":"priceList","props":{"id":"SXDX"}},{"type":"client","props":{"login":"39884"}}] */
  exclude?: FilterExclude[];
}

export interface FilterExclude {
  type: "priceList" | "client";
  props:
    | {
        id: string;
      }
    | {
        login: string;
      };
}

export interface FilterObject {
  type:
    | "priceList"
    | "priceListLabel"
    | "priceListGroup"
    | "brandName"
    | "brandLabel"
    | "brandNameNomenclature"
    | "nomenclatureLabel"
    | "brandNameInPriceList"
    | "webSupplier"
    | "wsAnalog"
    | "wsPLPart"
    | "rating"
    | "ratingOnWS"
    | "targetLabel"
    | "match";
  /**
   * Для каждого типа будет свой собственный JSON
   *   - priceList, убрать из результатов прайслист: {"priceList": "543"}. Только для локальных, не для вебов.
   *   - priceListLabel, убрать из результатов прайслист по лейблу: {"priceListLabel": "used"}
   *   - priceListGroup, убрать из результатов группу прайслистов: {"priceListGroup": "exampleGroup"}. Только для локальных, не для вебов.
   *   - brandName, убрать из результатов бренд: {"brandName": "bmw"}
   *   - brandLabel, убрать из результатов бренды с лейбом: {"brandLabel": "oil"}
   *   - brandNameNomenclature, убрать из результатов номенклатуру бренда: {"brandName": "bmw", "nomenclature": "BLK-C-555"}
   *   - nomenclatureLabel, убрать из результатов номенклатуру с лейблом: {"nomenclatureLabel": "counterfeit"}
   *   - brandNameInPriceList, убрать из результатов бренды из прайслиста: {"brandName": "bmw", "priceList": "543"}. Только для локальных, не для вебов.
   *   - webSupplier, убрать из результатов веб-поставщика (не делать запрос к): {"webSupplier": "tradesoft"}
   *   - wsAnalog, убрать из результатов аналоги веб-поставщика (добавить параметр к запросу): {"webSupplier": "tradesoft"}
   *   - wsPLPart, убрать из результатов позиции, прайс-лист веб-поставщика которого содержит подстроку (добавить параметр к запросу): {"webSupplier": "tradesoft", "part": "новосибирск"}
   *   - rating, убрать из результатов позиции, рейтинг которых входит в диапазон {"from": "10", "to": "50"}
   *   - ratingOnWS, убрать из результатов позиции веб поставщиков, рейтинг которых входит в диапазон {"from": "10", "to": "50", "webSupplier": "tradesoft"}
   *   - targetLabel, убрать из результатов позиции конкретного прайса/группы/веба с лейблом бренда или номенклатуры,  {"type":"targetLabel","identifiers":{"labelFor":"brand","label":"test","priceList":"SXDX","priceListGroup":"group","webSupplier":"0001","from":"10.1","to":"12.3"}}
   *   - match, убрать из результатов позиции конкретного прайса/группы/веба, {"type":"match","identifiers":{"brandName":"brand","brand":"00001904","nomenclature":"test","priceList":"SXDX","priceListGroup":"group","webSupplier":"0001","from":"10.1","to":"12.3"}}
   * @example {"priceList":"543","brand":"bmw","nomenclature":"BLK-C-555","webSupplier":"tradesoft"}
   */
  identifiers: Record<string, any>;
}

export interface ExtraCharge {
  /**
   * ## Обрезается до 256 знаков справа!
   * 0
   * Первая часть - прайс или веб поставщик и идентификатор через `=`
   * - g группа, например l=group
   * - c клиент, например c=my-login
   *
   * Через точку с запятой вторая часть - тип наценки и вес
   * - c общая, например c=1
   * - a дополнительная, например a=90
   *
   * Через точку с запятой третья часть - тип объекта и идентификаторы через `,` после `=`
   *
   * Для основной наценки:
   * - p_ прайс, например p_=SWCY
   * - pg прайс группа, например pg=price_group
   * - bp бренд в прайслистом, например bp=bmw,SWCY
   * - ws веб поставщик, например ws=tradesoft
   *
   * Для дополнительной:
   * - ws веб поставщик, например ws=tradesoft
   * - ad расширенная наценка, может включать диапазоны цен, прайс, бренд и номенклатуру, например ad=50.0,50.6
   * - tl наценка на лейблы конкретного поставщика/прайса/группы прайсов
   *
   * Примеры каждого типа:
   * - g=group;c=2;p_=SXYY
   * - g=group;c=1;bp=bmw,SWCY
   * - c=my_login;c=1;ws=tradesoft
   * - c=my_login;a=1;ws=tradesoft
   * - g=group;a=1;ad=100.0,1000.0,SXYY,bmw,blk-c-555
   */
  pk?: string;
  for: {
    type: "group" | "client";
    /** @example "my_login" */
    identifier: string;
  };
  ordering: {
    type: "common" | "additional";
    /** @example 1 */
    priority: number;
  };
  object: {
    type:
      | "webSupplier"
      | "brandName"
      | "priceList"
      | "priceListGroup"
      | "brandNameInPriceList"
      | "additional"
      | "nomenclatureLabel"
      | "targetLabel";
    /**
     * Для каждого типа будет свой собственный JSON.
     *
     * Все типы ordering (common, additional):
     *   - webSupplier, добавить наценку на веб-поставщика: {"webSupplier": "tradesoft"}.
     *
     * Только общая наценка (common):
     *   - priceList, добавить наценку на прайслист: {"priceList": "543"}.
     *   - priceListGroup, добавить наценку на группу прайслистов: {"priceListGroup": "test-group"}.
     *   - brandNameInPriceList, добавить наценку на бренд из прайслиста: {"brandName": "bmw", "priceList": "543"}.
     *
     * Только дополнительная наценка (additional):
     *   - additional, добавить наценку на предложения по параметрам: {"from": "55.10", "to": "500.4", "priceList": "PDPD",  "priceListGroup": "group1", "brand": "Volvo", "brandName": "Volvo", "nomenclature": "AC1111", "webSupplier": "0002"}.
     *   - nomenclatureLabel, добавить наценку на номенклатуру с лейблом: {"nomenclatureLabel": "counterfeit"}.
     *   - targetLabel, добавить наценку на предложения конкретного прайса/группы/веба с лейблом бренда или номенклатуры: {"from": "55.10", "to": "500.4", "labelFor":"brand","label":"test","priceList":"SXDX","priceListGroup":"group","webSupplier":"0001"}
     * @example {"priceList":"543","brand":"bmw","nomenclature":"BLK-C-555","webSupplier":"tradesoft"}
     */
    identifiers: Record<string, any>;
  };
  extraCharge: {
    valueType: "percent" | "fixed";
    /** @example 4.44 */
    value: number;
  };
}

export interface TrimBestPatch {
  /** @example 5 */
  articlePrice?: number;
  /** @example 5 */
  articleDelivery?: number;
  /** @example 5 */
  analogPrice?: number;
  /** @example 5 */
  analogDelivery?: number;
  /** @example 5 */
  articleRating?: number;
  /** @example 5 */
  articleQuantity?: number;
  /** @example 5 */
  analogRating?: number;
  /** @example 5 */
  analogQuantity?: number;
}

export interface TrimBestPost {
  /** @example "my_login" */
  client?: string;
  /** @example 5 */
  articlePrice: number;
  /** @example 5 */
  articleDelivery: number;
  /** @example 5 */
  analogPrice: number;
  /** @example 5 */
  analogDelivery: number;
  /** @example 5 */
  articleRating: number;
  /** @example 5 */
  articleQuantity: number;
  /** @example 5 */
  analogRating: number;
  /** @example 5 */
  analogQuantity: number;
}

export type TrimBest = TrimBestPost & {
  /** @example 42 */
  id: number;
};

export interface OptimizationLabel {
  /** @example "counterfeit" */
  name: string;
  type: "priceList" | "brand" | "nomenclature";
  /**
   * @max 256
   * @example 5
   */
  power: number;
}

export interface BrandPut {
  /** @example "BMW" */
  name: string;
  labels: string[];
  /** @example {"emex":"UP"} */
  integrationCodes?: Record<string, string>;
}

export type Brand = BrandPut & {
  /** @example "bmw" */
  code: string;
};

export interface BrandBatchState {
  /** @example 4 */
  index?: number;
  /** @example "bmw" */
  code?: string;
  state?: "duplicated ($index)" | "added" | "updated";
}

export interface BrandAliasPost {
  /** @example "бэха" */
  alias: string;
  type: "common" | "webSupplier" | "client";
  /** @example "tradesoft" */
  webSupplierCode?: string;
  /** @example "my_login" */
  client?: string;
}

export type BrandAlias = BrandAliasPost & {
  /** @example 34 */
  id: number;
};

export interface BrandNomenclaturePut {
  /** @example "643−2-BLK" */
  article: string;
  /** @example "Наклейка на Авто 30х30см" */
  name: string;
  /** @example "Наклейка на автомобиль клейкая легко отмываемая" */
  description: string;
  imageUrls: {
    /** @example "https://example.com/detail.png" */
    url: string;
    /** @example 200 */
    width: number;
    /** @example 100 */
    height: number;
  }[];
  /** @example 10.66 */
  recommendedMinimumPrice?: number;
  labels: string[];
  useChestnyZnak: boolean;
}

export type BrandNomenclature = BrandNomenclaturePut & {
  /** @example "643−2-BLK" */
  article: string;
  analogs: BrandNomenclatureAnalog[];
  state?: {
    salesCount?: number;
  };
};

export interface BrandNomenclatureBatchState {
  /** @example 4 */
  index?: number;
  /** @example "643−2-BLK" */
  article?: string;
  state?: "overridden" | "added" | "updated";
}

export interface BrandNomenclatureAnalogTaskSource {
  source: {
    code: string;
    name: string;
  };
  directionAs: "direct" | "inverted";
  /** @format date-time */
  createdAt: string;
}

export interface RichBrandNomenclatureAnalog {
  id: number;
  brandName: string;
  brandCode: string;
  article: string;
  viewedAsAnalog: boolean;
}

export interface BrandNomenclatureAnalog {
  id: number;
  /** @example "renault" */
  brandName: string;
  /** @example "000010" */
  brandCode: string;
  /** @example "643−2-BLK" */
  article: string;
}

export interface PriceListPut {
  /** @example 763 */
  rating?: number;
  supplier?: {
    /** @example "2422" */
    id: string;
    /** @example "ООО Масло и смазки" */
    name: string;
  };
  status: "disabled" | "enabled";
  /** @example ["used","official"] */
  labels: string[];
  /**
   * Is return available?
   * @default "limited"
   */
  returnCondition?: "impossible" | "possible" | "limited" | "unknown";
  groups?: string[];
  chestnyZnakKiz: "absence" | "exists" | "decline";
  chestnyZnakSendKizToEdo: "send" | "dont_send";
  /** @example {"CarMaker":["0000017","BRANDCODE"]} */
  labeledBrands?: Record<string, string[]>;
  rrpExtraCharge: {
    /** На весь прайс, по-умолчанию - 0 */
    common: number;
    perBrand: {
      /** @example "BRANDCODE" */
      brand: string;
      value: number;
    }[];
  };
}

export type PriceList = PriceListPut & {
  /** @example "402" */
  identifier: string;
};

export interface Price {
  /**
   * @maxLength 256
   * @example "Toyota"
   */
  brand: string;
  /**
   * @maxLength 256
   * @example "4002030404"
   */
  article: string;
  /** @example 10 */
  quantity: number;
  /** @example 400.5 */
  price: number;
  /** @example 2 */
  multiplicity: number;
}

export interface VaultPut {
  /** @example "MyP@assWord" */
  value: string;
}

export type Vault = VaultPut & {
  /** @example "TRADESOFT_PASS" */
  name: string;
};

export interface WebSupplier {
  /** @example "tradesoft" */
  code: string;
  /** @example "Supplier Name" */
  name: string;
  deliveryDayType: "calendar" | "work";
  /** @example false */
  analogEnrichEnabled: boolean;
  /** @example false */
  isBidirectionalAnalogEnrich: boolean;
  /** @example false */
  isStrictCodeSuggestion: boolean;
  status: "enabled" | "disabled";
  returnCondition?: "as-is" | "impossible" | "possible";
  trimBest: {
    /** @example 5 */
    articlePrice: number;
    /** @example 5 */
    articleDelivery: number;
    /** @example 5 */
    analogPrice: number;
    /** @example 5 */
    analogDelivery: number;
  };
  integrationType:
    | "emex"
    | "tradesoft"
    | "abcp"
    | "all_autoparts"
    | "froza"
    | "smart_trade"
    | "avtopiter"
    | "berg";
  forbiddenLabels?: string[];
  connection: {
    /** @example "https://192.168.1.42:4000/path" */
    baseUrl: string;
    /**
     * In ms
     * @example 1000
     */
    baseTimeout: number;
    articleSearch?: {
      /** @example "/articles" */
      path?: string;
      /**
       * In ms
       * @example 1000
       */
      timeout?: number;
      timeoutOverrides?: {
        recalculate: number;
        api: number;
        async: number;
        admin: number;
      };
    };
    brandSearch?: {
      /** @example "/brands" */
      path?: string;
      /**
       * In ms
       * @example 1000
       */
      timeout?: number;
    };
    auth: {
      /** @example "our-service" */
      login: string;
      /** @example "SERVICE_PASSWORD" */
      passwordEnv: string;
    };
    extraParameters: {
      /** @example "FROM" */
      key: string;
      /** @example "AvtoTransit" */
      value: string;
    }[];
  };
  cacheConfig?: {
    brandEnabled?: boolean;
    brandTtl?: number;
    suggestEnabled?: boolean;
    suggestTtl?: number;
  };
  chestnyZnakKiz: "absence" | "exists" | "decline";
  chestnyZnakSendKizToEdo: "send" | "dont_send";
}

export interface WebSupplierPatch {
  /** @example "Supplier Name" */
  name?: string;
  deliveryDayType?: "calendar" | "work";
  /** @example false */
  analogEnrichEnabled?: boolean;
  /** @example false */
  isBidirectionalAnalogEnrich?: boolean;
  /** @example false */
  isStrictCodeSuggestion?: boolean;
  trimBest?: {
    /** @example 5 */
    articlePrice: number;
    /** @example 5 */
    articleDelivery: number;
    /** @example 5 */
    analogPrice: number;
    /** @example 5 */
    analogDelivery: number;
  };
  status?: "enabled" | "disabled";
  integrationType?:
    | "emex"
    | "tradesoft"
    | "abcp"
    | "all_autoparts"
    | "froza"
    | "smart_trade"
    | "avtopiter"
    | "berg";
  forbiddenLabels?: string[];
  connection?: {
    /** @example "https://192.168.1.42:4000/path" */
    baseUrl: string;
    /**
     * In ms
     * @example 1000
     */
    baseTimeout: number;
    articleSearch?: {
      /** @example "/articles" */
      path?: string;
      /**
       * In ms
       * @example 1000
       */
      timeout?: number;
      timeoutOverrides?: {
        recalculate: number;
        api: number;
        async: number;
        admin: number;
      };
    };
    brandSearch?: {
      /** @example "/brands" */
      path?: string;
      /**
       * In ms
       * @example 1000
       */
      timeout?: number;
    };
    auth: {
      /** @example "our-service" */
      login?: string;
      /** @example "SERVICE_PASSWORD" */
      passwordEnv: string;
    };
    extraParameters: {
      /** @example "FROM" */
      key: string;
      /** @example "AvtoTransit" */
      value: string;
    }[];
  };
  cacheConfig?: {
    brandEnabled?: boolean;
    brandTtl?: number;
    suggestEnabled?: boolean;
    suggestTtl?: number;
  };
  chestnyZnakKiz?: "absence" | "exists" | "decline";
  chestnyZnakSendKizToEdo?: "send" | "dont_send";
}

export interface SuggestRequest {
  brand: string;
  article: string;
  client: string;
  options?: {
    useAnalogs?: "Y" | "N";
    proposalOnly?: "Y" | "N";
  };
}

export interface ProposalDeliveryInterval {
  subjectType: "priceList" | "webSupplier";
  /** @example "emex" */
  subjectIdentifier: string;
  /** @example "12:00:00" */
  hourDelimiter: string;
  before: {
    /** Nanoseconds */
    expected: number;
    /** Nanoseconds */
    guaranteed: number;
  };
  after: {
    /** Nanoseconds */
    expected: number;
    /** Nanoseconds */
    guaranteed: number;
  };
}

export interface LocalProposal {
  brandCode: string;
  brandName: string;
  article: string;
  priceListIdentifier: string;
  price: number;
  quantity: number;
  multiplicity: number;
  rating: number;
  /** @example {"a":true} */
  flags: Record<string, boolean>;
  minPrice: number;
  supplierName: string;
  returnCondition: string;
  priceListVersion: number;
  /** @format date-time */
  priceListUploadTime: string;
  priceListGroups: string[];
  chestnyZnakKiz: string;
  chestnyZnakSendKizToEdo: string;
}

/** @example {"isAnalog":false,"webSupplier":"0024","webSupplierName":"Сорбент","priceListIdentifier":"GMNK","article":"C110","brand":"VIC","localBrandCode":"000000197","quantity":2,"firstPrice":550,"price":594,"multiplicity":1,"labelMask":0,"delivery":{"expected":{"webSupplier":{"dayType":"calendar","date":"2024-12-03T08:56:19.565165148+03:00","days":4},"client":{"dayType":"calendar","date":"2024-12-03T08:56:19.565165148+03:00","days":4}},"guaranteed":{"webSupplier":{"dayType":"calendar","date":"2024-12-05T08:56:19.565165148+03:00","days":6},"client":{"dayType":"calendar","date":"2024-12-03T08:56:19.565165148+03:00","days":6}}},"rating":100,"flags":{},"brandName":"VIC","articleName":"Фильтр масляный VIC C-110   #A, #E, #S(2103n)","description":"","minPrice":0,"supplierName":"","returnCondition":"possible","stats":{"controlFlags":0,"priceListVersion":-1,"removedReason":{"reason":"","filterMessage":""},"deliveryIdx":100,"commonExtraChargeIdx":1077,"additionalExtraChargesIdxs":[]}} */
export interface AFProposal {
  isAnalog: boolean;
  webSupplier: string;
  webSupplierName: string;
  priceListIdentifier: string;
  article: string;
  cleanArticle?: string;
  requestedArticle?: string;
  originalBrandName?: string;
  requestedBrand?: string;
  brand: string;
  localBrandCode: string;
  quantity: number;
  firstPrice: number;
  price: number;
  currency: string;
  multiplicity: number;
  labelMask: string;
  delivery: {
    expected: any;
    guaranteed: any;
  };
  rating: number;
  brandName: string;
  articleName: string;
  description: string;
  minPrice: number;
  supplierName: string;
  returnCondition: string;
  systemInfo: {
    controlFlags: number;
    priceListVersion: number;
    priceListGroups: string[];
    removedReason: {
      reason: string;
      filterMessage: string;
    };
    deliveryIdx: number;
    commonExtraChargeIdx: number;
    additionalExtraChargesIdxs: number[];
    originalPrice?: {
      value: number;
      currency: string;
      exchangeRate: {
        id: number;
        value: number;
      };
    };
    priceListChestnyZnakKiz?: string;
    priceListChestnyZnakSendKizToEdo?: string;
  };
  /** @example {"official":true} */
  flags: Record<string, boolean>;
}

export interface AFProposalOnlySuggestionResponse {
  client: {
    login: string;
    logisticGroup: string;
    logisticGroupName: string;
    groups: string[];
    deliveryDayType: "work" | "calendar";
    requestLimits: {
      "5"?: number;
      concurrent?: number;
    };
    name: string;
    mop: string;
    class?: string;
    isUU?: boolean;
    rbCommission?: number;
    discount?: number;
    extraCharge?: number;
    chestnyZnakBehaviour?: string;
    chestnyZnakKizTransfer?: string;
  };
  proposals: AFProposal[];
  asyncKey?: string;
}

export type AFFullSuggestionResponse = AFProposalOnlySuggestionResponse & {
  workCalendars?: {
    /** @example {"2024-01-06":true,"2024-01-07":true} */
    currentYear: Record<string, boolean>;
    /** @example {"2024-01-06":true,"2024-01-07":true} */
    nextYear: Record<string, boolean>;
  };
  exchangeRates?: Record<
    string,
    {
      id: number;
      currencyFrom: string;
      currencyTo: string;
      date: string;
      rate: number;
    }
  >;
  arg: SuggestRequest;
  normalizedSubject?: {
    brand: {
      /** @example 416 */
      code: string;
      /** @example "Stellox" */
      name: string;
      labels: string[];
      integrationCodes: Record<string, string[]>;
    };
    article: {
      /** @example "1025142SX" */
      code: string;
      recommendedMinimumPrice: number;
      labels: string[];
      useChestnyZnak: boolean;
    };
  };
  filters: any[];
  extraCharges: any[];
  trimBest: {
    articlePrice: number;
    articleDelivery: number;
    analogPrice: number;
    analogDelivery: number;
    articleRating: number;
    articleQuantity: number;
    analogRating: number;
    analogQuantity: number;
  };
  deliveryIntervals: ProposalDeliveryInterval[];
  deliveryIntervalsWeek?: {
    monday: DeliveryInterval;
    tuesday: DeliveryInterval;
    wednesday: DeliveryInterval;
    thursday: DeliveryInterval;
    friday: DeliveryInterval;
    saturday: DeliveryInterval;
    sunday: DeliveryInterval;
  }[];
  analogs: {
    brand: string;
    brandName: string;
    sourceCode: string;
    article: string;
    salesCount: number;
    frequency: number;
  }[];
  /** @example {"timeTags":{"enrich":"2024-05-29T19:41:02.965625029+03:00","fill_client":"2024-05-29T19:41:01.960800837+03:00","fill_deliveries":"2024-05-29T19:41:02.961249537+03:00","filling":"2024-05-29T19:41:01.967207749+03:00","filling.fill_analog_block_id":"2024-05-29T19:41:01.967189059+03:00","filling.fill_extra_charges":"2024-05-29T19:41:01.965437394+03:00","filling.fill_filters":"2024-05-29T19:41:01.966523233+03:00","filling.fill_trim_best":"2024-05-29T19:41:01.963456458+03:00","filling.fill_work_calendar":"2024-05-29T19:41:01.962795685+03:00","mutate":"2024-05-29T19:41:02.963135044+03:00","normalize":"2024-05-29T19:41:01.958530674+03:00","notify":"2024-05-29T19:41:02.968073257+03:00","suggest":"2024-05-29T19:41:02.95887086+03:00","suggest.suggest_analog":"2024-05-29T19:41:01.967497665+03:00","suggest.suggest_local":"2024-05-29T19:41:01.990393695+03:00","suggest.suggest_web_supplier":"2024-05-29T19:41:02.958850056+03:00","trim_best":"2024-05-29T19:41:02.966918443+03:00"},"stepTime":{"enrich":2424942,"fill_analog_block_id":5704275,"fill_client":2161147,"fill_deliveries":2303324,"fill_extra_charges":4060362,"fill_filters":5044036,"fill_trim_best":2216264,"fill_work_calendar":1649839,"filling":6267034,"mutate":1830527,"normalize":3289518,"notify":1088908,"suggest":991573532,"suggest_analog":35026,"suggest_local":22959471,"suggest_web_supplier":991305401,"trim_best":1199781},"suggestTime":{"local":22941853,"localAnalog":0,"webSuppliers":{"0010":565645001,"aa":389370093,"froza":285313673,"testforb2":4332872,"tradesoft2":991184097,"tradesoft3":4096123,"tradesoft5":4256542}},"suggestionImmutableCount":{"local":11,"localAnalog":0,"webSuppliers":{"aa":20,"froza":23,"tradesoft2":0}}} */
  stats: {
    timeTags: Record<string, string>;
    stepTime: Record<string, number>;
    suggestTime: {
      local: number;
      localAnalog: number;
      webSuppliers: Record<string, number>;
    };
    suggestionImmutableCount: {
      local: number;
      localAnalog: number;
      webSuppliers: Record<string, number>;
    };
  };
  skippedProposals: AFProposal[];
  /** @example [{"code":"tradesoft3","reason":"error: Post \"https://192.168.1.42:4000/path/articles\": dial tcp 192.168.1.42:4000: connect: connection refused"},{"code":"tradesoft5","reason":"error: Post \"https://192.168.1.42:4000/path/articles\": dial tcp 192.168.1.42:4000: connect: connection refused"},{"code":"testforb2","reason":"error: Post \"https://192.168.1.42:4000/path/articles\": dial tcp 192.168.1.42:4000: connect: connection refused"},{"code":"0010","reason":"error: invalid character '<' looking for beginning of value"}] */
  failedWebSuppliers: {
    code: string;
    reason: string;
  }[];
};

export interface AFSuggestionAsyncState {
  state: "in_progress" | "done" | "clear";
  key: string;
  client: string;
  proposals: AFProposal[];
}

export interface CallWSResult {
  status: string;
  /** @example {"Content-Length":"1575517"} */
  headers: Record<string, string>;
  body: string;
  contentType: "json" | "xml" | "plain";
}

export interface PriceListRRP {
  items: {
    /** @example "BRANDCODE" */
    brand: string;
    /** @example "CLEANARTICLE" */
    article: string;
    value: number;
  };
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "https://in.atez.ru/api/ut/sp",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Scoring API
 * @version 1.0.0
 * @baseUrl https://in.atez.ru/api/ut/sp
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  authVerify = {
    /**
     * @description Verify client login and password
     *
     * @tags Login
     * @name AuthVerifyCreate
     * @summary Verify client login and password
     * @request POST:/auth-verify
     */
    authVerifyCreate: (
      data: {
        login: string;
        password: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          login: string;
          name: string;
          mop: string;
          mrk: string;
          holding: string;
          deliveryDayType: "work" | "calendar";
          roles: string[];
        },
        any
      >({
        path: `/auth-verify`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  group = {
    /**
     * @description Get groups
     *
     * @tags Group
     * @name GroupList
     * @summary Get groups
     * @request GET:/group
     */
    groupList: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example 1 */
          total: number;
          items: Group[];
        },
        any
      >({
        path: `/group`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Set up group
     *
     * @tags Group
     * @name GroupUpdate
     * @summary Set up group
     * @request PUT:/group/{code}
     */
    groupUpdate: (data: GroupPut, code?: string, params: RequestParams = {}) =>
      this.request<Group, any>({
        path: `/group/${code}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Set up group
     *
     * @tags Group
     * @name GroupDelete
     * @summary Set up group
     * @request DELETE:/group/{code}
     */
    groupDelete: (code?: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/group/${code}`,
        method: "DELETE",
        ...params,
      }),
  };
  searchClientFilters = {
    /**
     * @description Search values for filtering
     *
     * @tags Client
     * @name SearchClientFiltersCreate
     * @summary Search values for filtering
     * @request POST:/search-client-filters
     */
    searchClientFiltersCreate: (
      data: {
        limit: number;
        offset: number;
        filter: "logistic_group" | "mop" | "mrk" | "class";
        q?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: {
            key: string;
            displayValue: string;
          }[];
        },
        any
      >({
        path: `/search-client-filters`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  clientSearch = {
    /**
     * @description Get clients
     *
     * @tags Client
     * @name ClientSearchCreate
     * @summary Get clients
     * @request POST:/client-search
     */
    clientSearchCreate: (
      data: {
        logins: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example 1 */
          total: number;
          items: Client[];
        },
        any
      >({
        path: `/client-search`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  client = {
    /**
     * @description Get clients
     *
     * @tags Client
     * @name ClientList
     * @summary Get clients
     * @request GET:/client
     */
    clientList: (
      query?: {
        /** @example "my_lo" */
        q?: string;
        status?: "enabled" | "disabled";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example 1 */
          total: number;
          items: Client[];
        },
        any
      >({
        path: `/client`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get client
     *
     * @tags Client
     * @name RichList
     * @summary Get client
     * @request GET:/client/{login}/rich
     */
    richList: (login?: string, params: RequestParams = {}) =>
      this.request<RichClient, any>({
        path: `/client/${login}/rich`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Set up client
     *
     * @tags Client
     * @name ClientUpdate
     * @summary Set up client
     * @request PUT:/client/{login}
     */
    clientUpdate: (
      data: ClientPut,
      login?: string,
      params: RequestParams = {},
    ) =>
      this.request<Client, any>({
        path: `/client/${login}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete client
     *
     * @tags Client
     * @name ClientDelete
     * @summary Delete client
     * @request DELETE:/client/{login}
     */
    clientDelete: (login?: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/client/${login}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Set up client profile
     *
     * @tags Client
     * @name ProfileUpdate
     * @summary Set up client profile
     * @request PUT:/client/{login}/profile
     */
    profileUpdate: (
      data: ClientProfile,
      login?: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/client/${login}/profile`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  searchClientRich = {
    /**
     * @description Search clients with extended data
     *
     * @tags Client
     * @name SearchClientRichCreate
     * @summary Search clients with extended data
     * @request POST:/search-client-rich
     */
    searchClientRichCreate: (
      data: {
        logins?: string[];
        /** Имя/логин клиента (включая частичное совпадение) */
        name?: string;
        /** Код лог группы */
        logisticGroup?: string;
        mop?: string;
        mops?: string[];
        mrk?: string;
        class?: string;
        classes?: string[];
        participantType?: "legal" | "physycal";
        isUU?: boolean;
        orderField?:
          | "login"
          | "name"
          | "logisticGroup"
          | "mop"
          | "mrk"
          | "class";
        orderDirection?: "asc" | "desc";
        limit: number;
        offset: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total?: number;
          items?: RichClient[];
        },
        any
      >({
        path: `/search-client-rich`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  searchSuggestionLog = {
    /**
     * @description Get clients suggestion log (use `accept: text/csv` for csv response)
     *
     * @tags Suggestion Log
     * @name SearchSuggestionLogCreate
     * @summary Get clients suggestion log
     * @request POST:/search-suggestion-log
     */
    searchSuggestionLogCreate: (
      data: {
        /** @format datetime */
        from: string;
        /** @format datetime */
        to: string;
        clients?: string[];
        mop?: string;
        holding?: string;
        brand?: string;
        article?: string;
        hasResults?: boolean;
        withAnalogs?: boolean;
        requestedFrom?: "tradesoft" | "admin" | "client";
        /** @example 1 */
        queryTimeFrom?: number;
        /** @example 1 */
        queryTimeTo?: number;
        limit?: number;
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/search-suggestion-log`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  searchWsSuggestionLog = {
    /**
     * No description
     *
     * @tags Suggestion Log
     * @name SearchWsSuggestionLogCreate
     * @summary Get WS suggestion log
     * @request POST:/search-ws-suggestion-log
     */
    searchWsSuggestionLogCreate: (
      data: {
        /** @format datetime */
        from: string;
        /** @format datetime */
        to: string;
        clients?: string[];
        mop?: string;
        holding?: string;
        brand?: string;
        article?: string;
        hasResults?: boolean;
        withAnalogs?: boolean;
        requestedFrom?: "tradesoft" | "admin" | "client" | "basket-refresh";
        /** @example 1 */
        queryTimeFrom?: number;
        /** @example 1 */
        queryTimeTo?: number;
        limit?: number;
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/search-ws-suggestion-log`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  logisticGroup = {
    /**
     * @description Get logistic groups
     *
     * @tags Logistic Group
     * @name LogisticGroupList
     * @summary Get logistic groups
     * @request GET:/logistic-group
     */
    logisticGroupList: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example 1 */
          total?: number;
          items?: LogisticGroup[];
        },
        any
      >({
        path: `/logistic-group`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Add logistic group
     *
     * @tags Logistic Group
     * @name LogisticGroupCreate
     * @summary Add logistic group
     * @request POST:/logistic-group
     */
    logisticGroupCreate: (
      data: LogisticGroupPost,
      params: RequestParams = {},
    ) =>
      this.request<LogisticGroup, any>({
        path: `/logistic-group`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete logistic group
     *
     * @tags Logistic Group
     * @name LogisticGroupDelete
     * @summary Delete logistic group
     * @request DELETE:/logistic-group/{code}
     */
    logisticGroupDelete: (code?: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/logistic-group/${code}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Update logistic group
     *
     * @tags Logistic Group
     * @name LogisticGroupPartialUpdate
     * @summary Update logistic group
     * @request PATCH:/logistic-group/{code}
     */
    logisticGroupPartialUpdate: (
      data: LogisticGroupPatch,
      code?: string,
      params: RequestParams = {},
    ) =>
      this.request<LogisticGroup, any>({
        path: `/logistic-group/${code}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  delivery = {
    /**
     * @description Get deliveries
     *
     * @tags Delivery
     * @name DeliveryList
     * @summary Get deliveries
     * @request GET:/delivery
     */
    deliveryList: (
      query?: {
        /** @example "my_login" */
        client?: string;
        /** @example "group" */
        logistic_group?: string;
        /** @example "1234" */
        price_list?: string;
        /** @example "code" */
        web_supplier?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example 1 */
          total?: number;
          items?: Delivery[];
        },
        any
      >({
        path: `/delivery`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Set up deliveries
     *
     * @tags Delivery
     * @name DeliveryUpdate
     * @summary Set up deliveries
     * @request PUT:/delivery
     */
    deliveryUpdate: (
      data: Delivery[],
      query?: {
        remove?: 1 | 0;
      },
      params: RequestParams = {},
    ) =>
      this.request<Delivery[], any>({
        path: `/delivery`,
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete delivery
     *
     * @tags Delivery
     * @name DeliveryDelete
     * @summary Delete delivery
     * @request DELETE:/delivery/{pk}
     */
    deliveryDelete: (pk?: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/delivery/${pk}`,
        method: "DELETE",
        ...params,
      }),
  };
  workCalendar = {
    /**
     * @description Set up work calendar for year
     *
     * @tags Work Calendar
     * @name WorkCalendarUpdate
     * @summary Set up work calendar for year
     * @request PUT:/work-calendar/{year}
     */
    workCalendarUpdate: (
      year: number,
      data: WorkCalendarPut,
      params: RequestParams = {},
    ) =>
      this.request<WorkCalendar, any>({
        path: `/work-calendar/${year}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get work calendar
     *
     * @tags Work Calendar
     * @name WorkCalendarDetail
     * @summary Get work calendar
     * @request GET:/work-calendar/{year}
     */
    workCalendarDetail: (year: number, params: RequestParams = {}) =>
      this.request<WorkCalendar, any>({
        path: `/work-calendar/${year}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  optimizationLabel = {
    /**
     * @description Get optimization labels
     *
     * @tags Optimization Label
     * @name OptimizationLabelList
     * @summary Get optimization labels
     * @request GET:/optimization-label
     */
    optimizationLabelList: (
      query?: {
        type?: "priceList" | "brand" | "nomenclature";
      },
      params: RequestParams = {},
    ) =>
      this.request<OptimizationLabel[], any>({
        path: `/optimization-label`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Add optimization label
     *
     * @tags Optimization Label
     * @name OptimizationLabelCreate
     * @summary Add optimization label
     * @request POST:/optimization-label
     */
    optimizationLabelCreate: (
      data: {
        /** @example "counterfeit" */
        name: string;
        type: "priceList" | "brand" | "nomenclature";
      },
      params: RequestParams = {},
    ) =>
      this.request<OptimizationLabel, any>({
        path: `/optimization-label`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  filter = {
    /**
     * @description Get filter list
     *
     * @tags Filter
     * @name FilterList
     * @summary Get filter list
     * @request GET:/filter
     */
    filterList: (
      query?: {
        /** @example "my_login" */
        for_client?: string;
        /** @example "group-code" */
        for_group?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example 1 */
          total?: number;
          items?: Filter[];
        },
        any
      >({
        path: `/filter`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Set up filters
     *
     * @tags Filter
     * @name FilterUpdate
     * @summary Set up filters
     * @request PUT:/filter
     */
    filterUpdate: (
      data: Filter[],
      query?: {
        remove?: 1 | 0;
      },
      params: RequestParams = {},
    ) =>
      this.request<Filter[], any>({
        path: `/filter`,
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete filter
     *
     * @tags Filter
     * @name FilterDelete
     * @summary Delete filter
     * @request DELETE:/filter/{pk}
     */
    filterDelete: (pk: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/filter/${pk}`,
        method: "DELETE",
        ...params,
      }),
  };
  trimBest = {
    /**
     * @description Get trim best list
     *
     * @tags Trim Best
     * @name TrimBestList
     * @summary Get trim best list
     * @request GET:/trim-best
     */
    trimBestList: (
      query?: {
        /** @example "my_login" */
        for_client?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example 1 */
          total?: number;
          items?: TrimBest[];
        },
        any
      >({
        path: `/trim-best`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Add trim best
     *
     * @tags Trim Best
     * @name TrimBestCreate
     * @summary Add trim best
     * @request POST:/trim-best
     */
    trimBestCreate: (data: TrimBestPost, params: RequestParams = {}) =>
      this.request<TrimBest, any>({
        path: `/trim-best`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Set up trim bests
     *
     * @tags Trim Best
     * @name TrimBestUpdate
     * @summary Set up trim bests
     * @request PUT:/trim-best
     */
    trimBestUpdate: (data: TrimBestPost[], params: RequestParams = {}) =>
      this.request<TrimBest[], any>({
        path: `/trim-best`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get trim list
     *
     * @tags Trim Best
     * @name TrimBestDelete
     * @summary Get trim list
     * @request DELETE:/trim-best/{id}
     */
    trimBestDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/trim-best/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Get trim list
     *
     * @tags Trim Best
     * @name TrimBestPartialUpdate
     * @summary Get trim list
     * @request PATCH:/trim-best/{id}
     */
    trimBestPartialUpdate: (
      id: number,
      data: TrimBestPatch,
      params: RequestParams = {},
    ) =>
      this.request<TrimBest, any>({
        path: `/trim-best/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  extraCharge = {
    /**
     * @description Get extra charge list
     *
     * @tags Extra Charge
     * @name ExtraChargeList
     * @summary Get extra charge list
     * @request GET:/extra-charge
     */
    extraChargeList: (
      query?: {
        /**
         * @deprecated
         * @example "my_login"
         */
        for_client?: string;
        /**
         * @deprecated
         * @example "group-code"
         */
        for_group?: string;
        /** @example "group-code" */
        client?: string;
        /** @example "group-code" */
        group?: string;
        /** Используется с client. client - только наценки на клиента, group - только наценки на группы, в которых состоит клиент, не передано - все */
        scope?: "client" | "group";
        object_type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example 1 */
          total?: number;
          items?: ExtraCharge[];
        },
        any
      >({
        path: `/extra-charge`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Add extra charges
     *
     * @tags Extra Charge
     * @name ExtraChargeUpdate
     * @summary Add extra charges
     * @request PUT:/extra-charge
     */
    extraChargeUpdate: (
      data: ExtraCharge[],
      query?: {
        remove?: 1 | 0;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExtraCharge, any>({
        path: `/extra-charge`,
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete extra charge
     *
     * @tags Extra Charge
     * @name ExtraChargeDelete
     * @summary Delete extra charge
     * @request DELETE:/extra-charge/{pk}
     */
    extraChargeDelete: (pk: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/extra-charge/${pk}`,
        method: "DELETE",
        ...params,
      }),
  };
  brands = {
    /**
     * @description Set up brand list
     *
     * @tags Brand
     * @name BrandsCreate
     * @summary Set up brand list
     * @request POST:/brands
     */
    brandsCreate: (
      data: Brand[],
      query?: {
        force?: true;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example 1 */
          total?: number;
          items?: BrandBatchState[];
        },
        any
      >({
        path: `/brands`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  brand = {
    /**
     * @description Get brand list
     *
     * @tags Brand
     * @name BrandList
     * @summary Get brand list
     * @request GET:/brand
     */
    brandList: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example 0 */
          total?: number;
          items?: Brand[];
        },
        any
      >({
        path: `/brand`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Set up brand
     *
     * @tags Brand
     * @name BrandUpdate
     * @summary Set up brand
     * @request PUT:/brand/{code}
     */
    brandUpdate: (
      data: BrandPut,
      code?: string,
      query?: {
        force?: true;
      },
      params: RequestParams = {},
    ) =>
      this.request<Brand, any>({
        path: `/brand/${code}`,
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete brand
     *
     * @tags Brand
     * @name BrandDelete
     * @summary Delete brand
     * @request DELETE:/brand/{code}
     */
    brandDelete: (
      code: string,
      query?: {
        force?: true;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/brand/${code}`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * @description Set up brand nomenclature list
     *
     * @tags Nomenclature
     * @name NomenclaturesCreate
     * @summary Set up brand nomenclature list
     * @request POST:/brand/{code}/nomenclatures
     */
    nomenclaturesCreate: (
      code: string,
      data: BrandNomenclaturePut[],
      query?: {
        force?: true;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example 1 */
          total?: number;
          items?: BrandNomenclatureBatchState[];
        },
        any
      >({
        path: `/brand/${code}/nomenclatures`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get brand nomenclatures
     *
     * @tags Nomenclature
     * @name NomenclatureList
     * @summary Get brand nomenclatures
     * @request GET:/brand/{code}/nomenclature
     */
    nomenclatureList: (code: string, params: RequestParams = {}) =>
      this.request<
        {
          /** @example 1 */
          total?: number;
          items?: BrandNomenclature[];
        },
        any
      >({
        path: `/brand/${code}/nomenclature`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get brand nomenclature
     *
     * @tags Nomenclature
     * @name NomenclatureDetail
     * @summary Get brand nomenclature
     * @request GET:/brand/{code}/nomenclature/{article}
     */
    nomenclatureDetail: (
      code?: string,
      article?: string,
      params: RequestParams = {},
    ) =>
      this.request<BrandNomenclature, any>({
        path: `/brand/${code}/nomenclature/${article}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Set up brand nomenclature
     *
     * @tags Nomenclature
     * @name NomenclatureUpdate
     * @summary Set up brand nomenclature
     * @request PUT:/brand/{code}/nomenclature/{article}
     */
    nomenclatureUpdate: (
      data: BrandNomenclaturePut,
      code?: string,
      article?: string,
      query?: {
        force?: true;
      },
      params: RequestParams = {},
    ) =>
      this.request<BrandNomenclature, any>({
        path: `/brand/${code}/nomenclature/${article}`,
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete brand nomenclature
     *
     * @tags Nomenclature
     * @name NomenclatureDelete
     * @summary Delete brand nomenclature
     * @request DELETE:/brand/{code}/nomenclature/{article}
     */
    nomenclatureDelete: (
      code?: string,
      article?: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/brand/${code}/nomenclature/${article}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Get nomenclature analogs
     *
     * @tags Nomenclature Analog
     * @name NomenclatureAnalogList
     * @summary Get nomenclature analogs
     * @request GET:/brand/{code}/nomenclature/{article}/analog
     */
    nomenclatureAnalogList: (
      code?: string,
      article?: string,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: BrandNomenclatureAnalog;
        },
        any
      >({
        path: `/brand/${code}/nomenclature/${article}/analog`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get alias list
     *
     * @tags Brand Alias
     * @name AliasList
     * @summary Get alias list
     * @request GET:/brand/{code}/alias
     */
    aliasList: (
      code: string,
      query?: {
        /** @example "my_login" */
        for_client?: string;
        /** @example "tradesoft" */
        for_web_supplier?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example 0 */
          total?: number;
          items?: BrandAlias[];
        },
        any
      >({
        path: `/brand/${code}/alias`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Add brand alias
     *
     * @tags Brand Alias
     * @name AliasCreate
     * @summary Add brand alias
     * @request POST:/brand/{code}/alias
     */
    aliasCreate: (
      code: string,
      data: BrandAliasPost,
      params: RequestParams = {},
    ) =>
      this.request<BrandAlias, any>({
        path: `/brand/${code}/alias`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete brand alias
     *
     * @tags Brand Alias
     * @name AliasDelete
     * @summary Delete brand alias
     * @request DELETE:/brand/{code}/alias/{id}
     */
    aliasDelete: (code: string, id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/brand/${code}/alias/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  brandNomenclaturesStats = {
    /**
     * @description Set up nomenclatures stats
     *
     * @tags Nomenclature
     * @name BrandNomenclaturesStatsUpdate
     * @summary Set up nomenclatures stats
     * @request PUT:/brand-nomenclatures-stats
     */
    brandNomenclaturesStatsUpdate: (
      data: {
        brandCode: string;
        article: string;
        salesCount: number;
      }[],
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/brand-nomenclatures-stats`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  searchBrandNomenclatureAnalog = {
    /**
     * @description Search nomenclature analogs
     *
     * @tags Nomenclature Analog
     * @name SearchBrandNomenclatureAnalogCreate
     * @summary Search nomenclature analogs
     * @request POST:/search-brand-nomenclature-analog
     */
    searchBrandNomenclatureAnalogCreate: (
      data: {
        brand: string;
        article: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: RichBrandNomenclatureAnalog[];
        },
        any
      >({
        path: `/search-brand-nomenclature-analog`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  brandNomenclatureAnalogTask = {
    /**
     * @description Upload nomenclature analogs
     *
     * @tags Nomenclature Analog
     * @name BrandNomenclatureAnalogTaskCreate
     * @summary Upload nomenclature analogs
     * @request POST:/brand-nomenclature-analog-task
     */
    brandNomenclatureAnalogTaskCreate: (
      data: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/brand-nomenclature-analog-task`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),
  };
  brandNomenclatureAnalog = {
    /**
     * @description Get nomenclature analog task sources
     *
     * @tags Nomenclature Analog
     * @name TaskSourceList
     * @summary Get nomenclature analog task sources
     * @request GET:/brand-nomenclature-analog/{id}/task-source
     */
    taskSourceList: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          total: number;
          items: BrandNomenclatureAnalogTaskSource[];
        },
        any
      >({
        path: `/brand-nomenclature-analog/${id}/task-source`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  priceList = {
    /**
     * @description Get price lists
     *
     * @tags Price List
     * @name PriceListList
     * @summary Get price lists
     * @request GET:/price-list
     */
    priceListList: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example 1 */
          total: number;
          items: PriceList[];
        },
        any
      >({
        path: `/price-list`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Set up price list
     *
     * @tags Price List
     * @name PriceListUpdate
     * @summary Set up price list
     * @request PUT:/price-list/{identifier}
     */
    priceListUpdate: (
      identifier: string,
      data: PriceListPut,
      query?: {
        force?: true;
      },
      params: RequestParams = {},
    ) =>
      this.request<PriceList, any>({
        path: `/price-list/${identifier}`,
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Set up price list RRP
     *
     * @tags Price List
     * @name PutPriceList
     * @summary Set up price list RRP
     * @request PUT:/price-list/{identifier}/rrp
     */
    putPriceList: (
      identifier: string,
      data: PriceListRRP,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/price-list/${identifier}/rrp`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get price list RRP
     *
     * @tags Price List
     * @name GetPriceList
     * @summary Get price list RRP
     * @request GET:/price-list/{identifier}/rrp
     */
    getPriceList: (identifier: string, params: RequestParams = {}) =>
      this.request<PriceListRRP, any>({
        path: `/price-list/${identifier}/rrp`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Set up price list items
     *
     * @tags Price
     * @name PriceUpdate
     * @summary Set up price list items
     * @request PUT:/price-list/{identifier}/price
     */
    priceUpdate: (
      identifier: string,
      data: Price[],
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/price-list/${identifier}/price`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  priceListGroup = {
    /**
     * @description Get price list group
     *
     * @tags Price List
     * @name PriceListGroupDetail
     * @summary Get price list group
     * @request GET:/price-list-group/{code}
     */
    priceListGroupDetail: (code: string, params: RequestParams = {}) =>
      this.request<
        {
          code?: string;
        },
        any
      >({
        path: `/price-list-group/${code}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Set up price list group
     *
     * @tags Price List
     * @name PriceListGroupUpdate
     * @summary Set up price list group
     * @request PUT:/price-list-group/{code}
     */
    priceListGroupUpdate: (
      code: string,
      data: object,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/price-list-group/${code}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Delete price list group
     *
     * @tags Price List
     * @name PriceListGroupDelete
     * @summary Delete price list group
     * @request DELETE:/price-list-group/{code}
     */
    priceListGroupDelete: (
      code: string,
      query?: {
        force?: true;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/price-list-group/${code}`,
        method: "DELETE",
        query: query,
        ...params,
      }),
  };
  vault = {
    /**
     * @description Set up vault value
     *
     * @tags Vault
     * @name VaultUpdate
     * @summary Set up vault value
     * @request PUT:/vault/{name}
     */
    vaultUpdate: (name: string, data: VaultPut, params: RequestParams = {}) =>
      this.request<Vault, any>({
        path: `/vault/${name}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get vault
     *
     * @tags Vault
     * @name VaultList
     * @summary Get vault
     * @request GET:/vault
     */
    vaultList: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example 1 */
          total?: number;
          items?: Vault[];
        },
        any
      >({
        path: `/vault`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  webSupplier = {
    /**
     * @description Get web suppliers
     *
     * @tags Web Supplier
     * @name WebSupplierList
     * @summary Get web suppliers
     * @request GET:/web-supplier
     */
    webSupplierList: (
      query?: {
        /** @example "Гарант Ав" */
        q?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example 1 */
          total?: number;
          items?: WebSupplier[];
        },
        any
      >({
        path: `/web-supplier`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Add web supplier
     *
     * @tags Web Supplier
     * @name WebSupplierCreate
     * @summary Add web supplier
     * @request POST:/web-supplier
     */
    webSupplierCreate: (data: WebSupplier, params: RequestParams = {}) =>
      this.request<WebSupplier, any>({
        path: `/web-supplier`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update web supplier
     *
     * @tags Web Supplier
     * @name WebSupplierPartialUpdate
     * @summary Update web supplier
     * @request PATCH:/web-supplier/{code}
     */
    webSupplierPartialUpdate: (
      data: WebSupplierPatch,
      code?: string,
      params: RequestParams = {},
    ) =>
      this.request<WebSupplier, any>({
        path: `/web-supplier/${code}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete web supplier
     *
     * @tags Web Supplier
     * @name WebSupplierDelete
     * @summary Delete web supplier
     * @request DELETE:/web-supplier/{code}
     */
    webSupplierDelete: (code?: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/web-supplier/${code}`,
        method: "DELETE",
        ...params,
      }),
  };
  callWebSupplier = {
    /**
     * @description Add web supplier
     *
     * @tags Web Supplier
     * @name CallWebSupplierCreate
     * @summary Add web supplier
     * @request POST:/call-web-supplier
     */
    callWebSupplierCreate: (
      data: {
        wsCode: string;
        op: "brand" | "article";
        timeout: number;
        article: string;
        brand?: string;
        withAnalogs?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<CallWSResult, any>({
        path: `/call-web-supplier`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  suggestBrand = {
    /**
     * @description Suggest brand by article
     *
     * @tags Suggest
     * @name SuggestBrandList
     * @summary Suggest brand by article
     * @request GET:/suggest-brand
     */
    suggestBrandList: (
      query: {
        article: string;
        client: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: {
            /** @example "Stellox" */
            name: string;
            /** @example 4095 */
            code: string;
            articleName: string;
          }[];
        },
        any
      >({
        path: `/suggest-brand`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  matchFilter = {
    /**
     * @description Match filter
     *
     * @tags Suggest
     * @name MatchFilterCreate
     * @summary Match filter
     * @request POST:/match-filter
     */
    matchFilterCreate: (
      data: {
        client: string;
        proposal: AFProposal;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/match-filter`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  suggestAf = {
    /**
     * @description Suggest
     *
     * @tags Suggest
     * @name SuggestAfCreate
     * @summary Suggest
     * @request POST:/suggest-af
     */
    suggestAfCreate: (data: SuggestRequest, params: RequestParams = {}) =>
      this.request<
        AFFullSuggestionResponse | AFProposalOnlySuggestionResponse,
        any
      >({
        path: `/suggest-af`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get async suggestions
     *
     * @tags Suggest
     * @name AsyncProposalsDetail
     * @summary Get async suggestions
     * @request GET:/suggest-af/{client}/async-proposals/{key}
     */
    asyncProposalsDetail: (
      client: string,
      key: string,
      params: RequestParams = {},
    ) =>
      this.request<AFSuggestionAsyncState, any>({
        path: `/suggest-af/${client}/async-proposals/${key}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  suggestRecalculateAf = {
    /**
     * @description Suggest concrete proposals
     *
     * @tags Suggest
     * @name SuggestRecalculateAfCreate
     * @summary Suggest concrete proposals
     * @request POST:/suggest-recalculate-af
     */
    suggestRecalculateAfCreate: (
      data: {
        client?: string;
        /** @example {"objectKey":{"article":"1025142SX","brand":"000000416","webSupplier":"","priceListIdentifier":"SWU4"}} */
        proposals?: Record<
          string,
          {
            article: string;
            brand: string;
            webSupplier: string;
            priceListIdentifier: string;
          }
        >;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example {"objectKey":{"state":"ok","proposal":{"isAnalog":false,"webSupplier":"tradesoft2","priceListIdentifier":"Краснодар ARMT","article":"1025142SX","brand":"STELLOX","quantity":3,"firstPrice":6676,"price":6676,"multiplicity":1,"labelMask":0,"analogBlockId":null,"delivery":{"expected":{"webSupplier":{"dayType":"","date":"0001-01-01T00:00:00Z","days":null},"client":{"dayType":"","date":"0001-01-01T00:00:00Z","days":null}},"guaranteed":{"webSupplier":{"dayType":"","date":"0001-01-01T00:00:00Z","days":null},"client":{"dayType":"","date":"0001-01-01T00:00:00Z","days":null}}},"rating":93,"flags":{},"brandName":"STELLOX","articleName":"10-25142-SX_радиатор системы охлаждения!\\ Volvo S40/V40 1.6-2.0 16V 95","description":"","minPrice":0,"supplierName":"","returnCondition":"possible","stats":{"priceListVersion":-1,"firstPrice":6676,"removedReason":{"reason":"","filterMessage":""},"deliveryIdx":-1,"commonExtraChargeIdx":-1,"additionalExtraChargesIdxs":[]}}}} */
          proposals: Record<
            string,
            {
              state: "nil" | "ok" | "error";
              proposal?: AFProposal;
            }
          >;
        },
        any
      >({
        path: `/suggest-recalculate-af`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  suggestBestAf = {
    /**
     * @description Suggest best internal proposals
     *
     * @tags Suggest
     * @name SuggestBestAfCreate
     * @summary Suggest best internal proposals
     * @request POST:/suggest-best-af
     */
    suggestBestAfCreate: (
      data: {
        article: string;
        brand: string;
        fields: "price"[];
        config: {
          allowWebSupplier?: "yes" | "no" | "exclude";
          allowWebSupplierList?: string[];
          allowPriceList?: "yes" | "no" | "exclude";
          allowPriceListList?: string[];
          minQuantity?: number;
          filters?: FilterObject[];
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example {"price":[{"isAnalog":false,"webSupplier":"tradesoft2","priceListIdentifier":"Краснодар ARMT","article":"1025142SX","brand":"STELLOX","quantity":3,"firstPrice":6676,"price":6676,"multiplicity":1,"labelMask":0,"analogBlockId":null,"delivery":{"expected":{"webSupplier":{"dayType":"","date":"0001-01-01T00:00:00Z","days":null},"client":{"dayType":"","date":"0001-01-01T00:00:00Z","days":null}},"guaranteed":{"webSupplier":{"dayType":"","date":"0001-01-01T00:00:00Z","days":null},"client":{"dayType":"","date":"0001-01-01T00:00:00Z","days":null}}},"rating":93,"flags":{},"brandName":"STELLOX","articleName":"10-25142-SX_радиатор системы охлаждения!\\ Volvo S40/V40 1.6-2.0 16V 95","description":"","minPrice":0,"supplierName":"","returnCondition":"possible","stats":{"priceListVersion":-1,"firstPrice":6676,"removedReason":{"reason":"","filterMessage":""},"deliveryIdx":-1,"commonExtraChargeIdx":-1,"additionalExtraChargesIdxs":[]}}]} */
          results: Record<string, AFProposal[]>;
        },
        any
      >({
        path: `/suggest-best-af`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  searchLocalProposals = {
    /**
     * @description Search local proposals
     *
     * @tags Suggest
     * @name SearchLocalProposalsCreate
     * @summary Search local proposals
     * @request POST:/search-local-proposals
     */
    searchLocalProposalsCreate: (
      data: {
        article: string;
        brand: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          items: LocalProposal[];
        },
        any
      >({
        path: `/search-local-proposals`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
